import { render } from "./sim_report.vue?vue&type=template&id=21f89be5"
import script from "./sim_report.vue?vue&type=script&lang=js"
export * from "./sim_report.vue?vue&type=script&lang=js"

import "./sim_report.vue?vue&type=style&index=0&id=21f89be5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__